import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import React, { ForwardedRef, useEffect, useState } from "react"
import { Input, BaseInputProps } from "../Input/Input"
import { clamp } from "ramda"
import { classNames } from "../../../utils/classNames"
import { formatPercentage, parseNumber } from "@figurepos/fgr-lib-business-logic/lib/formatters/price_formatters"
import { Input as AntInput } from "antd"

export type PercentageInputProps = Omit<BaseInputProps, "value" | "prefix" | "onChange"> & {
    min?: number
    max?: number
    onChange?: (value: Maybe<number>) => void
    value?: Maybe<number>
}

export const PercentageInput = React.forwardRef(
    (
        {
            min = 0,
            max = 100,
            value,
            onChange: onChangeProp,
            onBlur: onBlurProp,
            className,
            ...restProps
        }: PercentageInputProps,
        ref: ForwardedRef<AntInput>
    ) => {
        const [inputValue, setInputValue] = useState("")

        useEffect(() => {
            setInputValue(value ? formatPercentage(value, null) : "")
        }, [value])

        const onChange = (e: any) => {
            setInputValue(e.target.value)
        }

        const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
            onBlurProp?.(e)

            const parsedValue = inputValue ? clampValue(parseNumber(inputValue, 3)) : null

            // Fire 'onChange' prop with raw parsed number
            onChangeProp?.(parsedValue)

            // Change the actual displayed input value to show formatted number
            setInputValue(parsedValue ? formatPercentage(parsedValue, null) : "")
        }

        const clampValue = (val: number) => clamp(min * 1000, max * 1000, val)

        return (
            <Input
                onChange={onChange}
                onBlur={onBlur}
                onFocus={e => {
                    const target = e.target
                    setTimeout(() => target?.select(), 50)
                }}
                className={classNames(className)}
                value={inputValue || ""}
                ref={ref}
                {...restProps}
            />
        )
    }
)

PercentageInput.displayName = "PercentageInput"
